import {
  Stack,
  Typography,
  useTheme,
  useMediaQuery
} from "@mui/material";
import { Download } from "lucide-react";
import { useParams } from "react-router-dom";
import { CardTabsLinkStack } from "./CardTabsLink.styles";
import type { CardTabsAttachmentProps } from "./CardTabsLink.types";
import {
  Link
} from "..";
import { useToolsLinkQuery } from "../../queries";

export function CardTabsAttachment({
  dimension,
  disabled,
  id: attachmentId,
  name,
  shortDescription,
  ...props
}: CardTabsAttachmentProps) {
  const theme = useTheme();
  const { id } = useParams();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { data: toolLink } = useToolsLinkQuery({
    enabled: !disabled,
    learningObjectId: id ?? "",
    toolId: attachmentId
  });

  const handleDownload = () => {
    if (!disabled && toolLink?.publicUrl) {
      const link = document.createElement("a");
      link.href = toolLink.publicUrl;
      link.download = "";
      link.target = "_blank";
      link.rel = "noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <CardTabsLinkStack
      { ...props }
      className={ disabled ? "not-allowed" : "pointer" }
      onClick={ handleDownload }
      style={ {
        cursor: disabled ? "not-allowed" : "pointer"
      } }
    >
      {
        shortDescription ? (
          <Typography
            fontWeight={ 300 }
            fontSize="1rem"
            lineHeight={ 11 / 8 }
            sx={ {
              [theme.breakpoints.down("sm")]: {
                fontSize:"0.875rem"
              },
              color: theme.customColors.exploreCardText
            } }
          >
            { shortDescription }
          </Typography>
        ) : null
      }
      <Stack
        alignItems="center"
        gap={ 1 }
        direction="row"
        sx={ {
          ".icon": {
            "path": {
              fill: disabled ? theme.customColors.textDisabled : theme.customColors.textWidget
            }
          }
        } }

      >
        <Link
          color="primary"
          fontSize={ isMobile ? "0.875rem" : "1.125rem" }
          style={ {
            color:disabled ? theme.customColors.textDisabled : theme.customColors.textWidget,
            cursor: "inherit",
            pointerEvents: "none",
            textDecoration: "none"
          } }
        >
          { name }
          <Download
            size={ 20 }
            color={ disabled ? theme.customColors.textDisabled : theme.customColors.textWidget }
            style={ { marginLeft: "4px" } }
          />
        </Link>
      </Stack>
      {
        <Typography
          fontSize="0.75rem"
          lineHeight={ 11 / 6 }
          sx={ {
            [theme.breakpoints.down("sm")]: {
              fontSize:"0.75rem"
            },
            color: theme.customColors.exploreCardText
          } }
        >
          { bytesToMegabytes(Number(dimension)) }
        </Typography>
      }
    </CardTabsLinkStack>
  );
}

function bytesToMegabytes(bytes: number) {
  const mb = bytes / 1000000;
  return `${mb.toFixed(2)} MB`;
}
